import { Directive } from '@angular/core';

/**
 * Contract for content projected into {@link SettingsListTabPageComponent}.
 * Implement by extending this class on a standalone component used as a child of
 * `<crowdctrl-settings-list-tab-page>…</crowdctrl-settings-list-tab-page>`, and put
 * **`#crowdctrlSettingsTabContent`** on that host (e.g. `<app-my-settings #crowdctrlSettingsTabContent />`)
 * so the shell can wire Apply / Cancel.
 *
 * The **routed** wrapper should implement Ionic `ViewWillEnter` / `ViewDidLeave` (or equivalent)
 * and call {@link SettingsListTabPageComponent.resetFooterActions} so Apply/Cancel spinners
 * clear when re-entering the stack or after leaving the page.
 */
@Directive()
export abstract class CrowdctrlSettingsTabPageContent {
  /** Used with unsaved-changes guards on the routed parent. */
  abstract hasUnsavedChanges(): boolean;

  /** Persist and leave (typically navigate). Reject or throw if work or navigation fails. */
  abstract applySettings(): Promise<void>;

  /** Discard and leave (typically navigate). Reject or throw if navigation fails. */
  abstract cancelSettings(): Promise<void>;
}
